import BaseForm from '../../template/BaseForm';
import React, { Component } from 'react';
import Form, { SimpleItem, GroupItem, TabbedItem, Tab } from 'devextreme-react/form';
import DataGrid from 'devextreme-react/data-grid';
import API from '../../services/AplicationService';
import { showSuccessMessage, showConfirmationMessage, showWarnMessage, handleError } from '../../utils/Utility';
import * as messages from '../../utils/Messages';
const initialState = {
	transportLogisticRoute: {},
};
const masterProps = {
	title: 'Cancelamento de Nota de Carregamento',
	subtitle: 'Cancele as notas de carregamento',
};
export default class CancelTransportLogisticRoute extends Component {
	state = { ...initialState };
	constructor(props) {
		super(props);
		this.getTransportLogistic = this.getTransportLogistic.bind(this);
		this.historicDataGrid = React.createRef();
		this.baseForm = React.createRef();
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.saveChangeStatusTransportLogisticRoute = this.saveChangeStatusTransportLogisticRoute.bind(this);
	}

	getTransportLogistic(key) {
		if (key) {
			this.baseForm.current.showLoadingPanel(true);
			API.get('transportLogisticRoutes/' + key)
				.then(response => {
					if (response.status !== 204) {
						this.transportLogisticRoute = { ...response.data };
						console.log(this.transportLogisticRoute);
						if (this.transportLogisticRoute.statusId !== 6) {
							this.setState({ ...this.state, transportLogisticRoute: this.transportLogisticRoute });
						} else {
							this.setStateDataToInitial();
							showWarnMessage('Essa nota de carregamento já está cancelada. Procure outra nota.');
						}
					} else {
						this.setStateDataToInitial();
						showWarnMessage(
							'Não foi encontrada nenhuma nota de carregamento com o número selecionado. Verifique e tente novamente.'
						);
					}
				})
				.catch(error => {
					handleError(error, messages.errorGetData);
				})
				.then(() => {
					this.baseForm.current.showLoadingPanel(false);
				});
		}
	}
	saveChangeStatusTransportLogisticRoute() {
		this.baseForm.current.showLoadingPanel(true);
		let changeStatusTransportLogisticRoute = {
			registerDate: this.transportLogisticRoute.canceledOn,
			statusId: 6,
			description: this.transportLogisticRoute.reasonCancellation,
			transportLogisticRoute: this.transportLogisticRoute,
		};

		if (
			changeStatusTransportLogisticRoute.transportLogisticRoute != null &&
			changeStatusTransportLogisticRoute.transportLogisticRoute.id !== null
		) {
			API.post('transportLogisticRoutes/ChangeStatusTransportLogisticRoute', changeStatusTransportLogisticRoute)
				.then(response => {
					showSuccessMessage('Cancelamento da ordem de carregamento realizada com sucesso!');
					this.setStateDataToInitial();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
				})
				.then(() => {
					this.baseForm.current.showLoadingPanel(false);
				});
		} else {
			showWarnMessage('É necessário selecionar a nota de carregamento antes de executar a operação.');
		}
	}
	setStateDataToInitial() {
		this.transportLogisticRoute = { ...initialState.transportLogisticRoute };
		this.setState({
			...this.state,
			transportLogisticRoute: this.transportLogisticRoute,
		});
	}
	onClickSave = function() {
		showConfirmationMessage(
			'Deseja realmente cancelar essa nota de carregamento?',
			this.saveChangeStatusTransportLogisticRoute
		);
	};
	onClickNew = function() {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};
	renderForm() {
		return (
			<React.Fragment>
				<Form
					formData={this.transportLogisticRoute}
					ref={this.form}
					showColonAfterLabel={false}
					labelLocation={'left'}
				>
					<GroupItem colCount={5} caption={'Informações Básicas'}>
						<SimpleItem
							colSpan={2}
							dataField={'id'}
							editorType={'dxNumberBox'}
							cssClass="uppercase"
							label={{ text: 'Nº' }}
							editorOptions={{
								disabled: false,
								onValueChanged: e => {
									this.getTransportLogistic(e.value);
								},
							}}
						/>
						<SimpleItem
							colSpan={1}
							dataField={'transportedOn'}
							editorType={'dxDateBox'}
							editorOptions={{
								disabled: true,
								type: 'datetime',
								displayFormat: 'dd/MM/yyyy HH:mm',
							}}
							label={{ text: 'Data/Hora' }}
						/>
						<SimpleItem
							dataField={'status'}
							editorOptions={{ disabled: true }}
							label={{ text: 'Status' }}
						/>
						<SimpleItem
							dataField={'weight'}
							colSpan={1}
							editorOptions={{
								disabled: true,
								min: 0,
								max: 9000000000000000,
								format: '#,###,##0.### kg',
							}}
							editorType={'dxNumberBox'}
							cssClass="uppercase"
							label={{ text: 'Peso' }}
						/>
						<SimpleItem
							dataField={'driver'}
							colSpan={3}
							editorOptions={{ disabled: true }}
							label={{ text: 'Motorista' }}
						/>
						<SimpleItem
							dataField={'vehicle'}
							colSpan={2}
							editorOptions={{ disabled: true }}
							label={{ text: 'Caminhão' }}
						/>
					</GroupItem>
					<GroupItem colCount={2} caption={'Rota de Carregamento'}>
						<SimpleItem
							dataField={'shippingCompany'}
							colSpan={2}
							editorOptions={{ disabled: true }}
							label={{ text: 'Transportadora' }}
						/>
						<SimpleItem
							dataField={'sender'}
							editorOptions={{ disabled: true }}
							label={{ text: 'Remetente' }}
						/>
						<SimpleItem
							dataField={'recipient'}
							editorOptions={{ disabled: true }}
							label={{ text: 'Destinatário' }}
						/>
						<SimpleItem
							dataField={'product'}
							editorOptions={{ disabled: true }}
							label={{ text: 'Produto' }}
						/>
						<SimpleItem dataField={'ship'} editorOptions={{ disabled: true }} label={{ text: 'Navio' }} />
					</GroupItem>
					<GroupItem
						colCount={2}
						caption={'Informações da Nota Fiscal'}
						visible={this.state.transportLogisticRoute.fiscalDocumentNumber ? true : false}
					>
						<SimpleItem
							dataField={'fiscalDocumentNumber'}
							cssClass="uppercase"
							editorOptions={{
								disabled: true,
							}}
							label={{ text: 'Nº da Nota', showColon: false }}
						/>
						<SimpleItem
							dataField={'fiscalDocumentDate'}
							editorType={'dxDateBox'}
							editorOptions={{
								type: 'datetime',
								disabled: true,
								displayFormat: 'dd/MM/yyyy HH:mm',
							}}
							label={{ text: 'Data da Emissão' }}
						/>
						<SimpleItem
							colSpan={2}
							editorOptions={{
								disabled: true,
							}}
							dataField={'fiscalDocumentBarCode'}
							label={{ text: 'Código de Barras', showColon: false }}
						/>
					</GroupItem>
					<GroupItem colCount={5} caption={'Informações do Cancelamento'}>
						<SimpleItem
							colSpan={4}
							dataField={'reasonCancellation'}
							label={{ text: 'Motivo de Cancelamento', showColon: false }}
						/>
						<SimpleItem
							dataField={'canceledOn'}
							editorType={'dxDateBox'}
							editorOptions={{
								type: 'datetime',
								displayFormat: 'dd/MM/yyyy HH:mm',
							}}
							label={{ text: 'Data do Cancelamento' }}
						/>
					</GroupItem>
					<TabbedItem
						tabPanelOptions={{
							onTitleClick: () => {
								if (this.historicDataGrid.current && this.transportLogisticRoute) {
									this.historicDataGrid.current.instance.option(
										'dataSource',
										this.transportLogisticRoute.historic
									);
								}
							},
						}}
					>
						<Tab title="Mais Informações">
							<SimpleItem
								dataField={'moreInformation'}
								editorOptions={{ disabled: true, inputAttr: { rows: 4 } }}
								editorType={'dxTextArea'}
								label={{ text: 'Observação', visible: false }}
							/>
						</Tab>
						<Tab title="Histórico" onTitleClick={this.onMoreInformationActiveTabChange}>
							<DataGrid
								repaintChangesOnly={true}
								ref={this.historicDataGrid}
								height={150}
								defaultColumns={[
									{
										dataField: 'onCreated',
										caption: 'Alterado em',
										dataType: 'date',
										format: 'dd/MM/yyyy HH:mm:ss',
									},
									{ dataField: 'createdBy', caption: 'Alterado por' },
									{
										dataField: 'registerDate',
										dataType: 'date',
										caption: 'Data do Registro',
										format: 'dd/MM/yyyy HH:mm',
									},

									{ dataField: 'status', caption: 'Status' },
									{ dataField: 'description', caption: 'Descrição' },
								]}
								showBorders={true}
							/>
						</Tab>
					</TabbedItem>
					<GroupItem>
						<div className="pull-right">
							<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
								<i className="fa fa-plus" />
								&nbsp; Novo
							</button>
							<button
								type="button"
								className="btn btn-success"
								onClick={this.onClickSave}
								disabled={!this.state.transportLogisticRoute.id}
							>
								<i className="fa fa-check" />
								&nbsp; Salvar
							</button>
						</div>
					</GroupItem>
				</Form>
			</React.Fragment>
		);
	}
	render(props) {
		return (
			<BaseForm {...masterProps} ref={this.baseForm}>
				<div className="box box-default padding-10">{this.renderForm()}</div>
			</BaseForm>
		);
	}
}
